<template>
    <div class="error-msg-wrap">
        <div class="error-msg">
            <div>{{msg}}</div>
            <div @click="cancel()" class="btn-invert" style="margin-right:10px">Cancel</div>
            <div @click="confirm()" class="btn" style="margin-left:10px">Yes</div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ConfirmDelete',
    props: ['msg'],
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        confirm() {
            this.$emit('confirm');
        }
    }
})
</script>